export const mutations = {
  addPermissions (state, permission) {
    state.permission = permission
  },
  setPermission (state, permission) {
    state.permission = permission
  }
}
